module.exports = __webpack_public_path__ + "static/img/6025_phase_function_Paper_PointsHejduk_Prediction.0004f5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6025_phase_function_Paper_PointsHejduk_Prediction.png
// module id = YONb
// module chunks = 0